export default {
  'tracking:page-title': 'Shipment Tracking',
  'tracking:title': 'Shipment Tracking',
  'tracking:status:1': '1. Your order in the online shop was successful',
  'tracking:status:2':
    '2. {employee} is currently taking care of your order in our shipping warehouse',
  'tracking:status:3':
    '3. Your order is ready for dispatch. As soon as the shipping company has received your package, you will receive detailed information below on the further course of the shipment:',
};
